import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export const DEFAULT_CMS_HEADING_TAG_LEVEL = 3;

@Component({
  selector: 'cms-heading-tag',
  templateUrl: './cms-heading-tag.component.html',
  styleUrls: ['./cms-heading-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsHeadingTagComponent {
  @Input() extraClasses: string;
  @Input() level = DEFAULT_CMS_HEADING_TAG_LEVEL;
}
